import { z } from 'zod'
export const WebsiteProbeSchema = z.object({
  url: z.string(), publiclyAccessible: z.boolean(), loginProtected: z.boolean(),
  loginCertainty: z.enum(['confirmed', 'none', 'unknown']),
  reason: z.enum(['ok', 'login', 'uncertain', 'private-host', 'unreachable', 'invalid-url']),
  statusCode: z.number().optional(), unreachableDetail: z.enum(['tls', 'dns', 'timeout', 'refused', 'other']).optional(),
})
